import { render, staticRenderFns } from "./SingleRemovePrivate.vue?vue&type=template&id=1e51a391"
import script from "./SingleRemovePrivate.vue?vue&type=script&lang=js"
export * from "./SingleRemovePrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports